import { render, staticRenderFns } from "./StudentsWrapper.vue?vue&type=template&id=4c31480a&"
import script from "./StudentsWrapper.vue?vue&type=script&lang=js&"
export * from "./StudentsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports